import React, {useEffect, useMemo, useState} from 'react';
import { Divider } from 'antd';
import {useDispatch, useSelector} from 'react-redux';
import moment from 'moment';
import AppText from "../../../../../../common/AppText";
import { GlobalStyleAttributes } from "../../../../../../../styles/GlobalStyles";
import { t } from "../../../../../../../services/i18n";
import VStack from "../../../../../../common/Layout/VStack";
import HStack from "../../../../../../common/Layout/HStack";
import Stack from "../../../../../../common/Layout/Stack";
import DropDownMenu from "../../../../../../common/DropDownMenu";
import { isMobile, isBoxIL } from "../../../../../../../services/Helpers";
import {toggleScheduleLoader, toggleSuccessFlag} from "../../../../../../../redux/ScheduleSlice";
import {WORKING_HOURS_SETTING} from "../../../../../../../services/ConstHelper";
import {fetchApi} from "../../../../../../../services/HTTP";
import {updateBox} from "../../../../../../../redux/boxSlice";
import {store} from "../../../../../../../redux/store";

const HOURS_MENU_STYLE = { maxHeight: '200px', overflowY: 'auto' };
const SUNDAY_FIRST_WEEK_ORDER = [0, 1, 2, 3, 4, 5, 6];
const MONDAY_FIRST_WEEK_ORDER = [1, 2, 3, 4, 5, 6, 0];

const WorkingHours = (props) => {
    const { values, setFieldValue } = props;
    const box = useSelector((state) => state.box.box);
    const shouldSave = useSelector((state) => state.schedule.settingsSaveFlag);
    const dispatch = useDispatch();

    const timeFormat = useMemo(() => (box ? box.locations_box[0].time_format : null), [box]);

    const weekOrder = isBoxIL() ? SUNDAY_FIRST_WEEK_ORDER : MONDAY_FIRST_WEEK_ORDER;

    const days = useMemo(() => {
        const allDays = [
            { id: 0, name: t('sunday') },
            { id: 1, name: t('monday') },
            { id: 2, name: t('tuesday') },
            { id: 3, name: t('wednesday') },
            { id: 4, name: t('thursday') },
            { id: 5, name: t('friday') },
            { id: 6, name: t('saturday') },
        ];
        return weekOrder.map(id => allDays.find(d => d.id === id));
    }, []);

    const hours = useMemo(() => {
        if (!timeFormat) return [];
        return Array.from({ length: 25 }, (_, h) => {
            const id = `${String(h).padStart(2, '0')}:00`;
            return { id, name: moment(id, 'HH:mm').format(timeFormat) };
        });
    }, [timeFormat]);

    const startDayItems = useMemo(() => {
        const endPos = weekOrder.indexOf(values?.workingHours?.endDay);
        return days.map(d => ({ ...d, disabled: weekOrder.indexOf(d.id) >= endPos }));
    }, [days, values?.workingHours?.endDay]);
    const endDayItems = useMemo(() => {
        const startPos = weekOrder.indexOf(values?.workingHours?.startDay);
        return days.map(d => ({ ...d, disabled: weekOrder.indexOf(d.id) <= startPos }));
    }, [days, values?.workingHours?.startDay]);
    const startHourItems = useMemo(() => hours.map(h => ({ ...h, disabled: h.id >= values?.workingHours?.endTime })), [hours, values?.workingHours?.endTime]);
    const endHourItems = useMemo(() => hours.map(h => ({ ...h, disabled: h.id <= values?.workingHours?.startTime })), [hours, values?.workingHours?.startTime]);

    useEffect(() => {
        if(shouldSave) {
            save()
        }
    }, [shouldSave]);

    useEffect(() => {
        console.log('values',values)
    }, [values]);

    const save = async () => {
        try {
            if (isMobile) {
                dispatch(toggleScheduleLoader(true));
                const setting = {prop_name: WORKING_HOURS_SETTING, properties: values.workingHours}
                const res = await fetchApi(`boxes/settings`, 'POST', setting, false, true);
                dispatch(toggleScheduleLoader(false));
                dispatch(toggleSuccessFlag(true))
                dispatch(updateBox({
                    settings: {
                        ...store.getState().box.box.settings,
                        [WORKING_HOURS_SETTING]: setting.properties
                    }
                }))
            }
        }catch(error) {
            console.log('error',error)
            dispatch(toggleScheduleLoader(false));
        }
    }
    const renderDaySelects = () => {
        const daySelect = (items, selected, onChange) => (
            <DropDownMenu title={days.find(d => d.id === selected)?.name} items={items} onPress={onChange} fontSize={GlobalStyleAttributes.fonts.standard16} showBorder width={'8.2rem'} styleOverride={{ height: '28px', width: isMobile ? '100%' : '8rem' }} />
        )
        return (
            <HStack alignItems={'center'} space={'0.5rem'}>
                {isMobile ? <HStack style={{ flex: 1 }}>{daySelect(startDayItems, values?.workingHours?.startDay, (val) => setFieldValue('workingHours.startDay', val))}</HStack> : daySelect(startDayItems, values?.workingHours?.startDay, (val) => setFieldValue('workingHours.startDay', val))}
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>-</AppText>
                {isMobile ? <HStack style={{ flex: 1 }}>{daySelect(endDayItems, values?.workingHours?.endDay, (val) => setFieldValue('workingHours.endDay', val))}</HStack> : daySelect(endDayItems, values?.workingHours?.endDay, (val) => setFieldValue('workingHours.endDay', val))}
            </HStack>
        );
    }

    const renderHourSelects = () => {
        const hourSelect = (items, selected, onChange) => (
            <DropDownMenu title={hours.find(h => h.id === selected)?.name} items={items} onPress={onChange} fontSize={GlobalStyleAttributes.fonts.standard16} showBorder width={'8.2rem'} styleOverride={{ height: '28px', width: isMobile ? '100%' : '8rem' }} menuStyle={HOURS_MENU_STYLE}/>
        )
        return (
            <HStack alignItems={'center'} space={'0.5rem'}>
                {isMobile ? <HStack style={{ flex: 1 }}>{hourSelect(startHourItems, values?.workingHours?.startTime, (val) => setFieldValue('workingHours.startTime', val))}</HStack> : hourSelect(startHourItems, values?.workingHours?.startTime, (val) => setFieldValue('workingHours.startTime', val))}
                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>-</AppText>
                {isMobile ? <HStack style={{ flex: 1 }}>{hourSelect(endHourItems, values?.workingHours?.endTime, (val) => setFieldValue('workingHours.endTime', val))}</HStack> : hourSelect(endHourItems, values?.workingHours?.endTime, (val) => setFieldValue('workingHours.endTime', val))}
            </HStack>
        );
    }

    return (
        <VStack space={'0.5rem'}>
            <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('workingHoursPreviewTxt')}</AppText>
            <VStack space={isMobile ? '1rem' : '0.2rem'}>
                <Stack direction={isMobile ? 'column' : 'row'} space={'0.5rem'} alignItems={isMobile ? 'unset' : 'center'} justifyContent={isMobile ? 'unset' : 'space-between'} py={isMobile ? '0' : '0.5rem'}>
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('daysDisplay')}</AppText>
                    {renderDaySelects()}
                </Stack>
                <Divider style={{ margin: '0' }} />
                <Stack direction={isMobile ? 'column' : 'row'} space={'0.5rem'} alignItems={isMobile ? 'unset' : 'center'} justifyContent={isMobile ? 'unset' : 'space-between'} py={isMobile ? '0' : '0.5rem'}>
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('hoursDisplay')}</AppText>
                    {renderHourSelects()}
                </Stack>
            </VStack>
        </VStack>
    );
};

export default WorkingHours;
